module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAP///zMzACwAAAAADAAMAAACFIyPqQsN/EJTcx1nb8wV1e5h2WgVADs="